import { ElementsFactories } from 'react-planner';

const info = {
  title: 'Square Shape',
  tag: ['shape'],
  description: 'Square Shape',
  image: require('./area-square-shape.png')
};

export default ElementsFactories.AreaFactory('area-square', info);
